import { useState } from 'react';
import { useMutation, useApolloClient } from '@apollo/client';
import { reportError } from '../../lib/reportError';
import { useErrorModal } from '../../hooks/useErrorModal';
import { useSavedItems } from '../../hooks/useSavedItems';
import { GET_SAVED_ITEMS_QUERY } from '../../hooks/useSavedItems/savedItems.rest';
import { LineItem, useCartVersion } from '../../hooks/useCart';
import { UPDATE_LINE_ITEM_MUTATION } from '../LineItem/lineItemMutations.rest';
import { useCountry } from '../CountrySelector';

export const useClearMovedAutomaticallyFlags = () => {
  const client = useApolloClient();
  const { country } = useCountry();
  const cartVersion = useCartVersion();
  const { savedItems } = useSavedItems();
  const { showErrorModal } = useErrorModal();
  const [mutate] = useMutation(UPDATE_LINE_ITEM_MUTATION);

  const [loading, setLoading] = useState(false);

  const movedItems = savedItems.filter(item => item.attributes.movedAutomatically);

  const clearMovedAutomaticallyFlagForItem = (item: LineItem) =>
    mutate({
      variables: {
        id: item.id,
        cartVersion,
        countryCode: country.alpha2Code,
        input: {
          data: {
            type: 'line_items',
            id: item.id,
            attributes: {
              sku_id: item.attributes.skuId,
              quantity: item.attributes.quantity,
              moved_automatically: false,
              type: 'SavedItem'
            }
          }
        }
      }
    });

  const clearMovedAutomaticallyFlags = async () => {
    setLoading(true);
    try {
      await Promise.all(movedItems.map(clearMovedAutomaticallyFlagForItem));
      await client.query({
        query: GET_SAVED_ITEMS_QUERY,
        variables: {
          countryCode: country.alpha2Code
        },
        fetchPolicy: 'network-only'
      });
    } catch (error) {
      showErrorModal();
      reportError('CLEAR_MOVED_AUTOMATICALLY_FLAGS', error);
    }
    setLoading(false);
  };

  return { clearMovedAutomaticallyFlags, loading };
};
